import { render, staticRenderFns } from "./Maintenance.vue?vue&type=template&id=756f622a&scoped=true&"
import script from "./Maintenance.vue?vue&type=script&lang=ts&"
export * from "./Maintenance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756f622a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pillar-science/pillar-science/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('756f622a')) {
      api.createRecord('756f622a', component.options)
    } else {
      api.reload('756f622a', component.options)
    }
    module.hot.accept("./Maintenance.vue?vue&type=template&id=756f622a&scoped=true&", function () {
      api.rerender('756f622a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Maintenance.vue"
export default component.exports